import _ from 'lodash';

import { pluralize } from '@zapier/common-utils';

import { CREDIT_CARD_URL } from 'app/settings/utils/constants';

type HeldReasonMessageMap = { [key: string]: string };

export const SEE_DETAILS_URLS = {
  stale_auth: '/app/connections',
  plan_limit: '/app/settings/billing',
};

export const MASS_REPLAY_STATUSES: { [key: string]: (n: number) => string } = {
  // successful replay
  success: n => `${n} ${pluralize('Task', n)} ran successfully!`,

  // did not attempt to replay:
  paused_zap: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because their associated Zaps are turned off. Turn on the Zap to enable replay.`,
  successful_task: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because they already ran successfully.`,
  outstanding_task: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because they’re already scheduled for replay.`,
  diverged_zap: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because the Zap has changed too much.`,
  expired_task: n =>
    `We didn’t retry ${n} ${pluralize('Task', n)} because the Task is too old.`,
  unsuccessful_task: n =>
    `${n} ${pluralize(
      'Task',
      n
    )} could not be replayed because they failed at the trigger step.`,
  deleted_zap: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because their associated Zaps no longer exist.`,
  playing_task: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because playing Tasks cannot be replayed.`,
  stale_auth: n =>
    `We couldn't play ${n} Tasks because a connected account expired.`,
  plan_limit: () =>
    'Could not cannot replay tasks because this account has hit its plan limit.',

  // replayed, but failed:
  error: n => `${n} ${pluralize('Task', n)} were stopped due to a Zap issue.`,
  halted: n => `${n} ${pluralize('Task', n)} were stopped due to a data issue.`,
  filtered: n =>
    `${n} ${pluralize('Task', n)} were stopped because they were filtered.`,
  delayed: n => `${n} ${pluralize('Task', n)} are waiting on a delay step.`,
  scheduled: n =>
    `${n} ${pluralize('Task', n)} are waiting on a schedule step.`,
  throttled: n => `${n} ${pluralize('Task', n)} were throttled.`,
};

export const MASS_REPLAY_ERRORS_FREE_PLAN: {
  [key: string]: (n: number) => string;
} = {
  ...MASS_REPLAY_STATUSES,
  successful_task: n =>
    `We didn’t retry ${n} ${pluralize(
      'Task',
      n
    )} because only held Tasks can be played.`,
};

export const MASS_DELETE_STATUSES: { [key: string]: (n: number) => string } = {
  // successful delete
  deleted: n => `${n} ${pluralize('Task', n)} deleted!`,

  // did not attempt to delete:
  expired_task: n =>
    `We couldn't delete ${n} ${pluralize(
      'Task',
      n
    )} because they were too old.`,
  playing_task: n =>
    `We couldn't delete ${n} ${pluralize(
      'Task',
      n
    )} because playing Tasks cannot be deleted.`,
};

export const SEE_DETAILS_TEXT: HeldReasonMessageMap = {
  stale_auth: 'Reconnect your account to try again.',
  plan_limit: 'Upgrade Now',
};

type FailureLink = { text: string; href: string };

export const PAYMENT_ISSUE = 'payment_issue';

export const GLOBAL_FAILURE_LINKS: { [k: string]: FailureLink } = {
  mass_replay_down: {
    text: 'Zapier Status',
    href: 'https://status.zapier.com',
  },
  plan_limit: {
    text: 'Upgrade Now',
    href: '/app/billing/plans',
  },
  [PAYMENT_ISSUE]: {
    text: 'Update Card',
    href: CREDIT_CARD_URL,
  },
};
